import { selectWaterTowerCanCollectWater } from "../../../selectors/selectWatertowerInfo";
export var checkIsWaterReadyForCollection = function (path) { return function (action, state$, deps) {
    var state = state$.value;
    if (!selectWaterTowerCanCollectWater(state)) {
        return;
    }
    return path;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/checks/checkIsWaterReadyForCollection.ts
// module id = 2510
// module chunks = 3